module.exports = __webpack_public_path__ + "static/img/after-sale-columba-0.d95f9dd3.png";